import App from './App.svelte';
const container = document.getElementById("glosbe-components");
const app = container ? new App({
    target: container,
}) : false;
export default app;
